import React from 'react'
import ShareButton from '../../ShareButton/ShareButton'
import Button from 'common/components/Button'
import Tooltip, { WithTooltip } from '../../common/Tooltip'
import Text from 'common/components/Text'

export const ViewControls = props => {
  const { anon, board, block, screenSize, t } = props
  if (block) {
    const originalSource = block.embed
      ? block.embed.url
      : block.image.originalLink || block.image.sourceUrl
    return (
      <>
        {originalSource && (
          <WithTooltip
            placement="bottom"
            tooltip={({ ref, show, hide, ...popperProps }) => (
              <Tooltip
                white
                multiline
                onMouseEnter={() => show(0)}
                onMouseLeave={() => hide(0)}
                innerRef={ref}
                {...popperProps}
              >
                <Text grey small bold>
                  <a
                    href={originalSource}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {originalSource}
                  </a>
                </Text>
              </Tooltip>
            )}
          >
            {({ ref, show, hide }) => (
              <Button
                href={originalSource}
                target="_blank"
                innerRef={ref}
                onMouseEnter={() => show(0)}
                onMouseLeave={() => hide(0)}
                style={{ cursor: 'alias' }}
              >
                {t('blockOptions.source')}
              </Button>
            )}
          </WithTooltip>
          // <SourceButton source={originalSource} placement="bottom" />
        )}
        {block.image && (
          <Button href={block.image.src} target="_blank">
            {t('toolbar.view.download')}
          </Button>
        )}
      </>
    )
  }
  if (!board) return null
  if (anon || screenSize.sizeClass === 'small') return null
  return <ShareButton item={board}>{t('toolbar.view.share')}</ShareButton>
}

export default ViewControls
